import { BAOCustomElement } from '@bao/custom-element'

class CarouselTabs extends BAOCustomElement() {
  setupListeners () {
    super.setupListeners()

    this.handleTabChange = this.handleTabChange.bind(this)

    this.els.trigger?.elements.forEach((triggerEl) => {
      this.listeners.add(triggerEl, 'click', this.handleTabChange)
    })
  }

  handleTabChange (event) {
    const clickedTrigger = event.currentTarget
    const activeIndex = clickedTrigger.dataset.index

    this.els.trigger?.elements.forEach((triggerEl) => {
      const isActive = triggerEl.dataset.index === activeIndex

      triggerEl.setAttribute('aria-selected', isActive ? 'true' : 'false')
    })

    this.els.panel?.elements.forEach((panelEl) => {
      const isActive = panelEl.dataset.index === activeIndex

      panelEl.hidden = !isActive
      panelEl.setAttribute('aria-hidden', isActive ? 'false' : 'true')

      if (isActive) {
        const carouselEl = panelEl.querySelector('css-carousel')

        carouselEl?.dispatchEvent(
          new CustomEvent('BAO::CSS_CAROUSEL::VISIBLE'),
        )
      }
    })
  }
}

if (!customElements.get('carousel-tabs')) {
  customElements.define('carousel-tabs', CarouselTabs)
}
